import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutContainer } from '../layout-container/LayoutContainer';
const PublicRoute = ({ component }) => {
    return _jsx(LayoutContainer, { children: component });
};
export default PublicRoute;
//# sourceMappingURL=PublicRoute.js.map